import React from "react";
import { Link } from "react-router-dom";
import { FaDiscord } from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-4">
          {/* Brand Logo */}
          <div className="md:col-span-1 flex items-start">
            <Link to="/" className="inline-block transition-opacity hover:opacity-80">
              <img 
                src="/Predict90HorizontalNoBG.png" 
                alt="Predict90" 
                className="h-20 w-auto"
                onError={(e) => {
                  console.error("Failed to load footer logo:", "/Predict90HorizontalNoBG.png");
                  e.target.style.display = 'none';
                }}
              />
            </Link>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xs font-semibold text-gray-900 mb-2 tracking-tight">Quick Links</h3>
            <ul className="space-y-1">
              <li>
                <Link 
                  to="/about" 
                  className="text-xs text-gray-600 hover:text-gray-900 transition-colors duration-200"
                >
                  About
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="text-xs text-gray-600 hover:text-gray-900 transition-colors duration-200"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-xs font-semibold text-gray-900 mb-2 tracking-tight">Legal</h3>
            <ul className="space-y-1">
              <li>
                <Link 
                  to="/terms" 
                  className="text-xs text-gray-600 hover:text-gray-900 transition-colors duration-200"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link 
                  to="/privacy" 
                  className="text-xs text-gray-600 hover:text-gray-900 transition-colors duration-200"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="text-xs font-semibold text-gray-900 mb-2 tracking-tight">Connect</h3>
            <div className="flex items-center gap-3">
              <a
                href="https://discord.gg/jGpvZqNRFj"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-600 hover:text-gray-900 transition-colors duration-200"
                aria-label="Join our Discord"
              >
                <FaDiscord className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-4 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2">
            <p className="text-xs text-gray-500">
              © {new Date().getFullYear()} Predict90. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <Link 
                to="/terms" 
                className="text-xs text-gray-500 hover:text-gray-900 transition-colors duration-200"
              >
                Terms
              </Link>
              <Link 
                to="/privacy" 
                className="text-xs text-gray-500 hover:text-gray-900 transition-colors duration-200"
              >
                Privacy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
